<ng-template #noLink>
  <span class="{{ classContainer }} {{ node.styleClasses }} {{ isCurrentUrl(node) ? 'current-url' : '' }} " style="flex-grow: 1">
    {{ node.title }}
  </span>
</ng-template>

@if (node.url) {
  <cx-generic-link
    [url]="node.url"
    [style]="node.styleAttributes"
    (click)="checkUrlAndCloseMenu()"
    class="w-100"
    [class]="node?.styleClasses || ''"
    [target]="isExternal(node.url) ? TARGET_TYPE.BLANK : TARGET_TYPE.SELF"
  >
    <ng-container *ngTemplateOutlet="noLink"> </ng-container>
  </cx-generic-link>
} @else {
  <ng-container *ngTemplateOutlet="noLink"> </ng-container>
}
